import * as React from 'react'
import { useRef, useState, Fragment } from 'react'
import { Divider } from '@foxrenderfarm/widgets'
import { MenuIcon, CloseIcon, DownArrowIcon } from './svg'
import {
  MenuIconWrapper,
  MobileMenuLink,
  MobileMenuItemsWrapper,
  MobileMenuWrapper,
  MobileSecondMenuWrapper,
  MobileSecondMenuContainer,
  MobileSecondMenuTitle,
  MobileMenuSecondLink,
  SupportDownloadWrapper,
  FreeIcon,
  DownloadTitle,
} from './atoms'
import { useClickAway } from '../../hooks'
import intl from 'react-intl-universal'
import { Link } from 'gatsby'
import { showNewsList } from '../../constants'
import { LOCALE } from '@foxrenderfarm/internals'

interface Props {
  items: (
    | {
        name: string
        to: string
        key: string
        children?: undefined
      }
    | {
        name: string
        key: string
        children: {
          key: string
          name: string
          to: string
        }[]
        to?: string
      }
  )[]
  handleChangeMobileNavShow: (v: boolean) => void
  currentLocale: LOCALE
}

const MobileSecondMenu = ({
  item,
  currentLocale,
}: {
  item: {
    name: string
    key: string
    children: { to: string; key: string; name: string }[]
  }
  currentLocale: LOCALE
}) => {
  const [openSecond, setOpenSecond] = useState(false)

  return (
    <MobileSecondMenuWrapper key={item.key}>
      <MobileSecondMenuTitle $isActive={openSecond} onClick={() => setOpenSecond(!openSecond)}>
        {item.name}
        <DownArrowIcon />
      </MobileSecondMenuTitle>
      {openSecond && (
        <>
          {item.key === 'support' && (
            <SupportDownloadWrapper
              to={currentLocale === 'en' ? '/download.html' : `/${currentLocale}/download.html`}
            >
              <DownloadTitle>{intl.get('index.header.support.download')}</DownloadTitle>
              <FreeIcon>{intl.get('index.header.support.free')}</FreeIcon>
            </SupportDownloadWrapper>
          )}
          <MobileSecondMenuContainer>
            {item.children.map((childrenItem) =>
              childrenItem.key === 'news' && !showNewsList.includes(currentLocale) ? null : (
                <MobileMenuSecondLink
                  key={childrenItem.key}
                  as={childrenItem.key === 'news' || item.key === 'support' ? 'a' : Link}
                  to={
                    currentLocale === 'en' ? childrenItem.to : `/${currentLocale}${childrenItem.to}`
                  }
                  href={childrenItem.to}
                >
                  {childrenItem.name}
                </MobileMenuSecondLink>
              ),
            )}
          </MobileSecondMenuContainer>
        </>
      )}
    </MobileSecondMenuWrapper>
  )
}

export const MobileNav = ({ items, handleChangeMobileNavShow, currentLocale }: Props) => {
  const [open, setOpen] = useState(false)
  const mobileMenuWrapRef = useRef<HTMLDivElement | null>(null)

  useClickAway(mobileMenuWrapRef, () => {
    if (open) {
      setOpen(false)
      handleChangeMobileNavShow(false)
    }
  })

  return (
    <MobileMenuWrapper ref={mobileMenuWrapRef}>
      <MenuIconWrapper
        onClick={() => {
          setOpen(!open)
          handleChangeMobileNavShow(!open)
        }}
      >
        {open ? <CloseIcon /> : <MenuIcon />}
      </MenuIconWrapper>
      {open && (
        <MobileMenuItemsWrapper>
          {items.map((item, index) => (
            <Fragment key={item.key}>
              {item.children ? (
                <MobileSecondMenu item={item} currentLocale={currentLocale} />
              ) : item.to ? (
                <MobileMenuLink
                  to={currentLocale === 'en' ? item.to : `/${currentLocale}${item.to}`}
                >
                  {item.name}
                </MobileMenuLink>
              ) : null}
              {index < items.length - 1 && <Divider width='100%' height='1px' />}
            </Fragment>
          ))}
        </MobileMenuItemsWrapper>
      )}
    </MobileMenuWrapper>
  )
}
